export default __webpack_public_path__ + "static/media/12.ca01ecca.jpg";